"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettlementPaymentStatus = void 0;
const type_graphql_1 = require("type-graphql");
var SettlementPaymentStatus;
(function (SettlementPaymentStatus) {
    SettlementPaymentStatus["PENDING"] = "Pending";
    SettlementPaymentStatus["READY_FOR_PAYMENT"] = "Ready for Payment";
    SettlementPaymentStatus["PAID"] = "Paid";
    SettlementPaymentStatus["UNPAID"] = "Unpaid";
})(SettlementPaymentStatus || (exports.SettlementPaymentStatus = SettlementPaymentStatus = {}));
(0, type_graphql_1.registerEnumType)(SettlementPaymentStatus, {
    name: "SettlementPaymentStatus",
});
//# sourceMappingURL=settlement-payment-status.js.map